import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../../Context";
import { useContext } from "react";
import { BASE } from "../../routes";

const PublicLayout = () => {
  const { user } = useContext(UserContext);
  const isLoggedIn = Boolean(user);

  if (isLoggedIn) {
    return <Navigate to={BASE} />;
  }

  return (
    <main className="bg-slate-100">
      <Outlet />
    </main>
  );
};

export default PublicLayout;
